import { useEffect, useState } from 'react'

const useResendCooldown = seconds => {
  const [secondsLeft, setSecondsLeft] = useState(0)

  useEffect(() => {
    if (secondsLeft === 0) return

    const interval = setInterval(() => setSecondsLeft(current => Math.max(current - 1, 0)), 1000)

    return () => clearInterval(interval)
  }, [secondsLeft])

  const restart = () => setSecondsLeft(seconds)

  return { secondsLeft, restart }
}

export default useResendCooldown
